import { ActionIcon, Group, Text, Tooltip } from '@mantine/core'

import { FaIcon, FaIconName, FaIconSet } from '#components/FaIcon'

import styles from './ExplorerHeaderButton.module.css'

export const ExplorerHeaderButton = ({
  tooltip,
  label,
  icon,
  iconSet,
  onClick,
  dropdownCaret,
}: {
  label?: string
  tooltip?: string
  onClick?: () => void
  icon?: FaIconName
  iconSet?: FaIconSet
  dropdownCaret?: boolean
}) => (
  <Tooltip position="bottom" label={tooltip ?? ''} disabled={!tooltip}>
    <ActionIcon
      aria-label={tooltip ?? label}
      onClick={onClick}
      variant="filled"
      p={6}
      className={styles.actionicon}
    >
      <Group gap={2}>
        {icon && <FaIcon fz={15} faIconSet={iconSet} icon={icon} fixedWidth />}
        {label && <Text size="16">{label}</Text>}
        {dropdownCaret && <FaIcon size="13" icon="fa-caret-down" />}
      </Group>
    </ActionIcon>
  </Tooltip>
)
